import axios from '@axios'
import { storePagination } from '@/mixins/store'
import moment from 'moment'
import { sorting } from '@/mixins'

const getInitialState = () => ({
  ...storePagination.state(),
  checkingAccountEntries: [],
  summaryFields: null,
  sorting: {
    sortBy: 'index',
    sortDesc: true,
  },
  filters: {
    storeId: null,
    checkingAccountId: null,
    period: {
      startDate: moment().toDate(),
      endDate: moment().toDate(),
    },
  },
  reportData: null,
})

export default {
  namespaced: true,

  state: getInitialState(),

  mutations: {
    ...storePagination.mutations,

    SET_CHECKING_ACCOUNT_ENTRIES(state, items) {
      state.checkingAccountEntries = items
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    SET_SUMMARY(state, summaryFields) {
      state.summaryFields = summaryFields
    },
    CLEAN_STATE(state) {
      const { checkingAccountEntries } = getInitialState()
      state.checkingAccountEntries = checkingAccountEntries
    },
    SET_REPORT_DATA(state, reportData) {
      state.reportData = reportData
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchCheckingAccountEntries({ commit, state }) {
      const { period } = state.filters
      const { data } = await axios.get('/api/financial/checking-account-entries', {
        params: {
          ...state.filters,
          startDate: period.startDate,
          endDate: period.endDate,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_CHECKING_ACCOUNT_ENTRIES', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
      commit('SET_SUMMARY', data.summaryFields)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
    async generateReport({ state, commit }) {
      const { period } = state.filters
      const { data } = await axios.get('/api/financial/checking-account-entries/download', {
        params: {
          ...state.filters,
          ...period,
        },
        responseType: 'blob',
      })

      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      commit('SET_REPORT_DATA', url)
    },
  },
}
